import type { AxiosInstance } from 'axios';
import type {
  Task,
  TaskDismissAllResponse,
  TaskDismissResponse,
  TaskListParams,
  TaskListResponse,
} from '../../constants';

/**
 * Task 목록 조회.
 * @description
 * - 본 프로젝트는 `limit: -1`로 전체를 받아 FE에서 탭(전체/진행중/성공/실패)을 필터링한다.
 */
export const getTaskList = async (
  instance: AxiosInstance,
  params?: TaskListParams,
  signal?: AbortSignal,
): Promise<TaskListResponse> => {
  return await instance.get('/v1/task/tasks', { params, signal });
};

/**
 * 단일 Task 상세 조회 ("상세 보기" / step 목록 포함).
 */
export const getTaskDetail = async (
  instance: AxiosInstance,
  taskId: string,
  signal?: AbortSignal,
): Promise<Task> => {
  return await instance.get(`/v1/task/tasks/${taskId}`, { signal });
};

/**
 * 단일 Task 숨김 처리 (성공/실패 항목 개별 제거).
 */
export const dismissTask = async (
  instance: AxiosInstance,
  taskId: string,
): Promise<TaskDismissResponse> => {
  return await instance.post(`/v1/task/tasks/${taskId}/dismiss`);
};

/**
 * 표시 가능한 Task 전체 숨김 처리 ("성공/실패 태스크 제거").
 */
export const dismissAllTasks = async (instance: AxiosInstance): Promise<TaskDismissAllResponse> => {
  return await instance.post('/v1/task/tasks/dismiss-all');
};
